"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lspCompletionSnippet = void 0;
function lspCompletionSnippet(segments) {
    var n = 1;
    return segments
        .map(function (segment) { return (Array.isArray(segment) ? lspPlaceholder(n++, segment) : segment); })
        .join('');
}
exports.lspCompletionSnippet = lspCompletionSnippet;
function lspPlaceholder(i, choices) {
    // Escape $ } \ , | in choices
    // https://microsoft.github.io/language-server-protocol/specifications/lsp/3.17/specification/#grammar
    var escapedChoices = choices
        .filter(function (choice) { return choice !== ''; })
        .map(function (choice) { return choice.replace(/([$\\},|])/g, '\\$1'); });
    return "${".concat(i, "|").concat(escapedChoices.join(','), "|}");
}
//# sourceMappingURL=lspCompletionSnippet.js.map